const nordmartiniqueplanner = {
  key: 'nordmartiniqueplanner',
  canonicalUrl: 'https://tourismenordmartinique.fr',
  datalayerId: 'GTM-N7FRS7X',
  customerId: 709,
  icon: 'nordmartinique.png',
  headerLogo: 'nordmartinique.png',
  logoLink: 'https://tourismenordmartinique.fr/',
  footerLogo: 'nordmartinique_monochrome.png',
  axeptioClientId: '',
  axeptioCookiesVersion: 'nordmartinique.com',
  clientUrl: 'https://tourismenordmartinique.fr/',
  proUrl: 'https://tourismenordmartinique.fr/',
  languageSelector: true,
  sanity: {
    base: {
      projectId: '8uheavee',
      dataset: 'production',
      apiVersion: '2022-12-01',
      useCdn: true,
    },
    preview: {
      useCdn: false,
      withCredentials: true,
      token:
        'sk5n89iQrOQqdxc12WvYcIpriTcnZgjeNkAQdxPgwtkXq4JyavyQYY1SH6ibFrNtTQF8g3IHGxLTlClPNDV5C5cokxMdqbU9kIP9RkOUgHZJIPjjOcjrtTZDarAV90bGtlnKvoWm7sMJHrkXqYx9UCT1ggOYjQj2uofQ1EIRFrKb3uk5BQzb',
    },
  },
  dev: {
    clientUrl: 'https://tourismenordmartinique.fr/',
    proUrl: 'https://tourismenordmartinique.fr/',
  },
  travelForceLogin: false,
};

export default nordmartiniqueplanner;
